import { APP_CONSTANTS } from '@/config/constants';
import { databaseService } from '@/services/databaseService';
import type { PendingRecoveryItem } from '@/types/recovery';
import { digestRecoveryPendingRow } from './recoveryPendingDigest';

interface PendingInventoryDatabase {
  listItems<T>(collection: string, query?: unknown): Promise<T[]>;
}

const mapQueue = (
  queue: 'pending_operations' | 'pending_deletions',
  rows: Array<Record<string, unknown>>
): Array<Pick<PendingRecoveryItem, 'pendingId' | 'sourceDigest'>> => rows.map(row => {
  const id = String(row.id ?? '').trim();
  if (!id) throw new Error(`Pendencia sem id em ${queue}.`);
  return {
    pendingId: `${queue}:${id}`,
    sourceDigest: digestRecoveryPendingRow(queue, row),
  };
});

export const collectRecoveryPendingInventory = async (
  database: PendingInventoryDatabase = databaseService
): Promise<Array<Pick<PendingRecoveryItem, 'pendingId' | 'sourceDigest'>>> => {
  const [operations, deletions] = await Promise.all([
    database.listItems<Record<string, unknown>>(
      APP_CONSTANTS.DATABASE.TABLES.PENDING_OPERATIONS.NAME
    ),
    database.listItems<Record<string, unknown>>(
      APP_CONSTANTS.DATABASE.TABLES.PENDING_DELETIONS.NAME
    ),
  ]);
  return [
    ...mapQueue('pending_operations', operations),
    ...mapQueue('pending_deletions', deletions),
  ].sort((left, right) => left.pendingId.localeCompare(right.pendingId));
};
